const server = process.env.REACT_APP_SERVER;

export async function getReflection(userId, type, dateStr) {
    try {
        const requestParams = {
            collectionName: userId,
            type: type,
            startDate: dateStr
        };
        const response = await fetch(`${server}/reflection?${new URLSearchParams(requestParams)}`);
        const result = await response.json();
        return result;
    }
    catch (e) {
        console.error(e, 'getReflection');
    }
}

export async function createOrUpdateReflection(reflection) {
    try {
        const jsonBody = JSON.stringify(reflection);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json'},
            body: jsonBody
        };
        const response = await fetch(`${server}/reflection`, requestOptions);
        const result = await response.json();
        return result;
    }
    catch (e) {
        console.error(e, 'createOrUpdateReflection');
    }
}